import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden" data-id="element-88">
      <div className="max-w-6xl mx-auto" data-id="element-89">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-90">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-91">
            <span className="inline-block px-4 py-1.5 mb-6 text-sm font-bold tracking-wider text-[#FC8EAC] uppercase bg-[#FC8EAC]/10 rounded-full" data-id="element-92">
              For Women 55+
            </span>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-[#2C2C2C] mb-6" data-id="element-93">
              Stop the 3am Menopause <br className="hidden md:block" data-id="element-94" />
              <span className="text-[#FC8EAC]" data-id="element-95">Wake-Up Loop</span> (In 14
              Nights)
            </h1>

            <p className="text-xl md:text-2xl text-[#4A4A4A] mb-8 leading-relaxed" data-id="element-96">
              The 7pm routine that makes sleep possible again. No pills, no
              "sleep hygiene" checklists—just a biological reset.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 items-start" data-id="element-97">
              <Button withIcon onClick={() => document.getElementById('pricing')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-98">
                Get The 14-Night Reset
              </Button>
              <p className="text-sm text-[#666] mt-4 sm:mt-0 sm:ml-4 italic" data-id="element-99">
                Instant PDF Download + Tracker
              </p>
            </div>
          </motion.div>

          {/* Hero Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative" data-id="element-100">
            <img src="https://cdn.magicpatterns.com/uploads/acxz6rHnXD9QsHhk5kidvz/heylloyd-image-1769228551960.png" alt="Woman holding tablet showing The 7pm Menopause Sleep Reset" className="w-full h-auto rounded-2xl shadow-2xl" data-id="element-101" />
          </motion.div>
        </div>

        {/* Opening Lead Box */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.6,
        duration: 0.8
      }} className="mt-16 p-8 bg-white rounded-2xl shadow-sm border border-[#E5E0D8] text-left max-w-3xl mx-auto" data-id="element-102">
          <h3 className="text-xl font-bold mb-4 font-serif" data-id="element-103">
            It's not the tiredness that breaks you.
          </h3>
          <p className="text-lg text-[#4A4A4A] mb-4" data-id="element-104">
            It's the <strong data-id="element-105">3am wake-up</strong>—when your body feels switched
            "on," your mind starts scanning for problems, and you can{' '}
            <em data-id="element-106">feel tomorrow getting ruined in real time.</em>
          </p>
          <p className="text-lg text-[#4A4A4A]" data-id="element-107">
            You're not failing at sleep. You've just been trying to fix it in
            the wrong order.
          </p>
        </motion.div>
      </div>
    </section>;
}